import styled from "styled-components"

const List = styled.ul`
  margin-bottom: 10px;
  padding-left: 40px;
`

export default List
